import { FC } from 'react';

import {
  Text,
  Button,
  Center,
  Popover,
  PopoverBody,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';

type Props = {
  isDeleting: boolean;
  onDelete: () => void;
};

export const DeletePickupButton: FC<Props> = ({ onDelete, isDeleting }) => {
  return (
    <Popover size="lg">
      {({ onClose }) => (
        <>
          <PopoverTrigger>
            <Button variant="danger" isLoading={isDeleting}>
              Delete
            </Button>
          </PopoverTrigger>
          <PopoverContent w="200px" bg="primary.200">
            <PopoverArrow bg="primary.200" />
            <PopoverBody py="20px">
              <Text
                mb="20px"
                lineHeight="1"
                color="#fff"
                textAlign="center"
                fontSize="14px"
                fontWeight="600">
                Are you sure
                <br />
                you want to delete?
              </Text>
              <Center gap="10px">
                <Button size="sm" variant="outline" onClick={onClose}>
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => {
                    onDelete();
                    onClose();
                  }}>
                  Delete
                </Button>
              </Center>
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};
